<template>
  <div>
    <Header :notHome="true" @goScroll="goScroll"></Header>
    <pageNav :navList="navList" :current="currentActive" title="人才招聘" @navClick="navClick"></pageNav>
    <div class="main-content-area">
      <div class="recruit-area" ref="recruitArea">
        <div class="area-bg" ref="bgArea" :style="`{top:${offsetTop}px}`">
          <div class="bg-img">
            <img src='../../assets/image/bg33.png' class="d-sm-none d-xl-block" />
            <img src='../../assets/image/bg34.png' class="d-sm-block d-xl-none" />
          </div>
        </div>
        <div class="recruit-box">
          <b-container fluid>
            <b-row class="page-model-title-row">
              <b-col xl="12">
                <div class="recruid-item flex align-center" v-for="(item, index)  in list" :key="index" @click="goDetail(item)">
                  <div class="item-left flex flex-column">
                    <span>{{ item.showTime[0] }}</span>
                    <span>{{ item.showTime[1] }}</span>
                  </div>
                  <div class="item-right flex align-center justify-between">
                    <div class="overHidden">{{ item.title }} </div>
                    <div class="img d-sm-none d-xl-block"></div>
                  </div>
                </div>
                <!-- 获得底部位置判断是否加载下一页数据 -->
                <div ref="lastDiv"></div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </div>
    <Footer @goScroll="goScroll"></Footer>
  </div>
</template>
<script>
import { getRecruit } from "@/api/recruit"
export default {
  data() {
    return {
      navList: [{
        title: '招聘公告'
      }, {
        title: '结果公示'
      }
      ],
      currentActive: 0,
      endDivTop: 0,
      currentPage: 1,
      list: [],
      type: 0,
      pages: 1,
      loading:false,
      offsetTop:0,
      tempTimeout:null
    }
  },
  mounted() {
    this.countViewCount()
    if(this.$route.query.to!=undefined){
          this.navClick({index:Number(this.$route.query.to)})
    }else{
      this.getRecruit()
    }
    this.$nextTick(() => {
      this.offsetTop=this.$refs.recruitArea.offsetTop
      this.$refs.bgArea.style.top=(this.offsetTop-10)+'px'
      this.endDivTop = this.$refs.lastDiv.offsetTop
      window.addEventListener("scroll", this.handleScroll)
    })
  },
  destroyed(){
    window.removeEventListener("scroll", this.handleScroll)
  },
  methods: {
    getRecruit() {
      getRecruit({ pageSize: 10, pageNum: this.currentPage,categoryType:(this.type+1) }).then((res) => {
        if(res.code==200&&res.rows&&res.rows.length!=0){
          let tempList=res.rows[0].list.map(t => {
            let d = t.createTime.substring(0, 10).split('-')
            t.showTime = [d[0], `${d[1]}-${d[2]}`]
            return t
          })
          this.pages=Math.ceil(res.total/10)
          if(this.currentPage==1){
            this.list=tempList
          }else{
            this.list=this.list.concat(tempList)
          }
        }
        // if (res.code == 200) {
        //   let obj = res.rows.find(t => t.name == '招聘广告') || { list: [] }
        //   let temp = obj.list.map(t => {
        //     let d = t.createTime.substring(0, 10).split('-')
        //     t.showTime = [d[0], `${d[1]}-${d[2]}`]
        //     return t
        //   })
        //   if (temp.length != 0) {
        //     if (this.currentActive == 0 && this.currentPage != 1) {
        //       let listTemp = this.list[0].concat(temp)
        //       this.list.splice(0, 1, listTemp)
        //     } else if (this.currentPage == 1) {
        //       this.list.splice(0, 1, temp)
        //     }
        //   } else {
        //     if (this.currentActive == 0) {
        //       this.nextPage = false
        //     }
        //   }
        //   let obj2 = res.rows.find(t => t.name == '结果公告') || { list: [] }
        //   let temp2 = obj2.list.map(t => {
        //     let d = t.createTime.substring(0, 10).split('-')
        //     t.showTime = [d[0], `${d[1]}-${d[2]}`]
        //     return t
        //   })
        //   if (temp2.length != 0) {
        //     if (this.currentActive == 1 && this.currentPage != 1) {
        //       let listTemp = this.list[1].concat(temp2)
        //       this.list.splice(1, 1, listTemp)
        //     } else if (this.currentPage == 1) {
        //       this.list.splice(1, 1, temp2)
        //     }
        //   } else {
        //     if (this.currentActive == 1) {
        //       this.nextPage = false
        //     }
        //   }
        // }
      }).finally(()=>{
        this.loading=false
      })
    },
    navClick({ item, index }) {
      this.nextPage = true
      this.currentActive = index
      this.type = index
      this.currentPage = 1
      this.list=[]
      window.scrollTo({
        top:0,
        behavior: "smooth"
      })
      this.getRecruit()
    },
    goDetail(item) {
      // this.setStore({name:'recruitDetail',content:{...item}})
      setTimeout(()=>{
        this.$router.push({ path: '/recruitDetail?id=' + item.recruitId + '&type=' + this.type })
      },300)
    },
    handleScroll(e) {
      this.offsetTop=this.$refs.recruitArea.getBoundingClientRect().top<160?160:this.$refs.recruitArea.getBoundingClientRect().top
      this.$refs.bgArea.style.top=(this.offsetTop-10)+'px'
      if(this.list.length==0)return
      let nowTop = e.target.scrollTop || document.documentElement.scrollTop
      if (nowTop - this.endDivTop > 200 && (this.currentPage<this.pages)&&!this.loading) {
        this.loading=true
        // 滑动到底了且有下一页
        this.currentPage = this.currentPage + 1
        this.getRecruit()
      }
    },
    goScroll(index) {
      this.navClick({ index: Number(index) })
    }
  }
}
</script>
<style lang="scss" scoped>
.recruit-area {
  // background: linear-gradient(to bottom, #d3e1f5 0, #fff 700px);
  min-height: 600px;
  .area-bg{
    width: 100%;
    z-index: -1;
    position: fixed;
    min-height: 2774px;
  }
  .recruit-box {
    max-width: 1200px;
    min-height: 100vh;
    margin: 0 auto;
    padding-top: 60px;
    padding-bottom: 40px;
    .recruid-item {
      background: #ffffff;
      box-shadow: 0px 0 23px 0px rgba(10, 49, 128, 0.1);
      padding: 15px;
      overflow: hidden;
      cursor: pointer;
      margin-bottom: 15px;

      .item-left {
        flex-shrink: 0;
        padding: 0 20px;
        border-right: 2px solid rgba(21, 102, 212, 0.5);

        > span:first-of-type {
          font-family: "SourceHanSansCN-Regular";
          font-weight: bold;
          font-size: 34px;
          color: #333333;
          line-height: 41px;
        }

        > span:last-of-type {
          font-family: "SourceHanSansCN-Regular";
          font-weight: 400;
          font-size: 22px;
          color: #666666;
          line-height: 33px;
        }
      }

      .item-right {
        flex: 1;
        min-width: 0;
        padding: 0 20px 0 15px;
        overflow: hidden;

        > div:first-of-type {
          font-family: "SourceHanSansCN-Regular";
          font-weight: bold;
          font-size: 24px;
          color: #333333;
          min-width: 0;
          flex: 1;
        }

        .img {
          width: 50px;
          height: 14px;
          flex-shrink: 0;
          background-image: url("../../assets/image/icon9.png");
          background-size: contain;
          background-repeat: no-repeat;
        }
      }
    }

    .recruid-item:hover {
      .item-left {
        > span:first-of-type {
          color: #1566d4;
        }
        > span:last-of-type {
          color: #1566d4;
        }
      }
      .item-right {
        > div:first-of-type {
          font-weight: bold;
          color: #1566d4;
        }

        .img {
          background-image: url("../../assets/image/icon8.png");
        }
      }
    }
  }
}

// 移动端
@media (min-width: 576px)and (max-width:1200px){
.recruit-bg{
  height: calc(100vh - 524px)!important;
}
.recruid-item {
  .item-left{
    >span:first-of-type{
      font-size: 36px!important;
    }
    >span:last-of-type{
      font-size: 22px!important;
    }
  }
  .item-right{
    div{
      font-size: 28px!important;
    }
  }
}
.recruid-item:hover{
  border-bottom: 2px solid #1566d4;
}
}
</style>